import * as analytics from '@gitbook/app-analytics/client';
import { Button, Description, Heading } from '@gitbook/spine-react';

import { apiClient } from '../../../state';
import {
    TemplateCard,
    TemplateCardActions,
    TemplateCardFooter,
    TemplateCardImage,
    TemplateCardPreview,
} from '../../Templates';
import type { SpaceCreationOnCreateSpace } from './types';

export interface BlankTemplateCardProps {
    organizationId: string;
    onCreateSpace: SpaceCreationOnCreateSpace;
    /** Select the blank-space flow without creating the space immediately. */
    onSelectBlankSpace?: () => void;
    compact?: boolean;
}

export function BlankTemplateCard(props: BlankTemplateCardProps) {
    const { organizationId, onCreateSpace, onSelectBlankSpace, compact } = props;

    return (
        <TemplateCard>
            <TemplateCardPreview>
                <TemplateCardImage
                    className={compact ? 'aspect-auto! h-24!' : undefined}
                    src={{
                        light: 'https://gitbookio.github.io/onboarding-template-images/templates/blank.png',
                        dark: 'https://gitbookio.github.io/onboarding-template-images/templates/blank-dark.png',
                    }}
                />
                <TemplateCardActions>
                    <Button
                        label="Start with blank"
                        onPress={async () => {
                            if (onSelectBlankSpace) {
                                onSelectBlankSpace();
                                return;
                            }
                            await onCreateSpace(async ({ collectionId }) => {
                                const { data: space } = await apiClient.spaces.createSpace(
                                    organizationId,
                                    { parent: collectionId }
                                );
                                analytics.logEvent(
                                    analytics.createSpaceEvent(space, {
                                        type: 'space_create',
                                        source: 'blank',
                                    })
                                );
                                return space;
                            });
                        }}
                    />
                </TemplateCardActions>
            </TemplateCardPreview>
            <TemplateCardFooter className={compact ? 'p-3!' : undefined}>
                <div className="flex flex-col gap-1">
                    <Heading className={compact ? 'text-ui-heading-small' : undefined}>
                        Blank
                    </Heading>
                    <Description>An empty space to start from scratch.</Description>
                </div>
            </TemplateCardFooter>
        </TemplateCard>
    );
}
